import script from "./ysc.vue?vue&type=script&setup=true&lang=js"
export * from "./ysc.vue?vue&type=script&setup=true&lang=js"

import "./ysc.vue?vue&type=style&index=0&id=41a386b9&scoped=true&lang=css"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41a386b9"]])

export default __exports__